import { Field, Form, Formik } from "formik"

import { ICredentials } from "@api/schema"
import { FormButtonArea } from "@components/common/form/FormButtonArea"
import FormikInput from "@components/common/form/FormikInput"
import GeneralFormError from "@components/common/form/GeneralFormError"

interface IProps {
  onSubmit: (...args: any) => void
  credentials?: ICredentials
}

/**
 * This component provides a Login-Form
 */
const LoginForm: React.FC<IProps> = ({ onSubmit, credentials = {
  password: "",
  username: "",
} }: IProps) => {

  return <Formik<ICredentials> initialValues={credentials} onSubmit={onSubmit}>
    {({
      errors,
      handleSubmit,
      isSubmitting,
      values,
    }) => <Form onSubmit={handleSubmit}>
        <GeneralFormError
          errors={errors}
          prefix="user"
          excludeFields={["password", "username"]}
        />
        <Field component={FormikInput}
          help="form.login.username.help"
          label="form.login.username.label"
          name="username"
          placeholder="form.login.username.placeholder"
          required
          value={values.username}
        />

        <Field component={FormikInput}
          help="form.login.password.help"
          label="form.login.password.label"
          name="password"
          placeholder="form.login.password.placeholder"
          required
          type="password"
          value={values.password}
        />

        {
          /* @todo required asterisk
           * Currently not needed, because, the translations for the labels are empty and the required asterisk will be attached to the label
           * <p className="text-danger">{t("form.requiredFieldsHint")}</p>
           */
        }

        <FormButtonArea
          isSubmitting={isSubmitting}
          submitButton={{
            title: "form.login.submit",
            iconName: "user",
          }}
        />
      </Form>
    }
  </Formik>
}

export default LoginForm
